// extracted by mini-css-extract-plugin
module.exports = {"groupContainer":"MyGroup_groupContainer__HGMR7","groupLabel":"MyGroup_groupLabel__4aF7u"};